import { render, staticRenderFns } from "./ExpertItemReplaceIndex.vue?vue&type=template&id=56a2faaa&scoped=true"
import script from "./ExpertItemReplaceIndex.vue?vue&type=script&lang=js"
export * from "./ExpertItemReplaceIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a2faaa",
  null
  
)

export default component.exports